<template>
  <div>

    <Head :title="`${user.data.name}`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-accent-primary-text" href="/users">Gebruikers</Link>
        <span class="text-accent-primary-text font-medium">/</span>
        {{ user.data.name }}
      </h1>
      <!-- <img v-if="user.data.avatar" class="block ml-4 w-8 h-8 rounded-full" :src="user.data.avatar" /> -->
    </div>

    <div class="flex flex-wrap">
      <div class="w-full">
        <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
          <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
            <!-- <Link class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal cursor-pointer" :href="`/users/${user.data.id}?activeTab=details`" v-bind:class="{'text-accent-primary-text bg-white': openTab !== 'details', 'text-accent-primary-text bg-accent-primary': openTab === 'details'}"> -->
            <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal cursor-pointer"
              v-on:click="toggleTabs('details')"
              v-bind:class="{'text-accent-primary-text bg-white': openTab !== 'details', 'text-accent-primary-text bg-accent-primary': openTab === 'details'}">
              Details
              <!-- </Link> -->
            </a>
          </li>

          <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
            <!-- <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal cursor-pointer" :href="`/users/${user.data.id}?activeTab=loans`" v-bind:class="{'text-accent-primary-text bg-white': openTab !== 'loans', 'text-accent-primary-text bg-accent-primary': openTab === 'loans'}"> -->
            <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal cursor-pointer"
              v-on:click="toggleTabs('loans')"
              v-bind:class="{'text-accent-primary-text bg-white': openTab !== 'loans', 'text-accent-primary-text bg-accent-primary': openTab === 'loans'}">
              Uitleningen
            </a>
          </li>
        </ul>
        <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
          <div class="px-4 py-5 flex-auto">
            <div class="tab-content tab-space">
              <div v-bind:class="{'hidden': openTab !== 'details', 'block': openTab === 'details'}">
                <user-tab :user="user" />
              </div>

              <div v-bind:class="{'hidden': openTab !== 'loans', 'block': openTab === 'loans'}">
                <queue-tab :loans="user.data.loans.data" :order="order" :direction="direction" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import UserTab from './UserTab.vue'
import QueueTab from './QueueTab.vue'

export default {
  components: {
    Head,
    UserTab,
    QueueTab    
  },
  layout: Layout,
  props: {
    user: Object,
    order: String,
    direction: String
  },

  data() {
    return {
      openTab: 'details'
    }
  },

  mounted() {
    let params = new URLSearchParams(window.location.search);
    this.openTab = params.get('activeTab') ?? 'details'
  },  

  methods: {
    toggleTabs: function(tabName){
      this.openTab = tabName

       window.location = `/users/${this.user.data.id}` + this.replaceQueryParam('activeTab', tabName, window.location.search)
    },

    replaceQueryParam: function(param, newval, search) {
        var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
        var query = search.replace(regex, "$1").replace(/&$/, '');

        return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval : '');
    }

  },
}
</script>